import { PRICE_HEADER_ID } from 'components/www/availability-search/filters/SearchFiltersDialog';
import { SearchFiltersFieldNames } from 'components/www/availability-search/SearchHeader';
import {
  FormSwitcherRadioButton as SwitcherField,
  SwitcherGroup,
  SwitcherGroupDivider,
} from 'omakase';
import { currencyCodeToSymbol } from '@tock/money';
import { useCurrencyContext } from '@tock/coretypes';
import React from 'react';

interface PriceOption {
  value: number;
  'aria-label': string;
}

export const priceRangeDefaultValue = '-1';

const priceOptionsAndLabels: PriceOption[] = [
  {
    value: 1,
    'aria-label': 'Low price',
  },
  {
    value: 2,
    'aria-label': 'Medium price',
  },
  {
    value: 3,
    'aria-label': 'High price',
  },
  {
    value: 4,
    'aria-label': 'Very high price',
  },
];

interface SearchFilterPriceRangeProps {
  className?: string;
}

const SearchFilterPriceRange: React.FunctionComponent<SearchFilterPriceRangeProps> = ({
  className,
}) => {
  const currencyCode = useCurrencyContext();
  const currency = currencyCodeToSymbol(currencyCode);
  const switcherOptions = priceOptionsAndLabels.map(({ value, 'aria-label': ariaLabel }) => {
    return (
      <React.Fragment key={`${value}`}>
        <SwitcherGroupDivider />
        <SwitcherField
          aria-label={ariaLabel}
          variant="basic"
          name={SearchFiltersFieldNames.priceRange}
          type="radio"
          value={`${value}`}
          label={currency.repeat(value)}
        />
      </React.Fragment>
    );
  });
  return (
    <>
      <SwitcherGroup aria-labelledby={PRICE_HEADER_ID} background className={className}>
        <SwitcherField
          variant="basic"
          name={SearchFiltersFieldNames.priceRange}
          type="radio"
          value={priceRangeDefaultValue}
          label="All"
        />
        {switcherOptions}
      </SwitcherGroup>
    </>
  );
};

export default SearchFilterPriceRange;
